import { WORK_FETCHING, WORK_FAILED, WORK_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case WORK_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case WORK_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case WORK_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
